import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Input,
  Button,
  Row,
  Col,
  FormGroup,
  Label,
  FormFeedback,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import usePersistStoreData from "../Hooks/usePersistStoreData";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

const EditDobModal = ({ edit_dob, close_editDob }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;

  const initialValues = {
    user_dob: "",
  };
  const validationSchema = Yup.object({
    user_dob: Yup.date()
      .required("Date of Birth is required")
      .max(new Date(), "Date of Birth cannot be in the future"),
  });

  return (
    <Modal isOpen={edit_dob} centered={true} className="contact_modal_custom">
      <ModalHeader
        toggle={close_editDob}
        style={{
          backgroundColor: "#0F528D",
          paddingTop: "0.75rem",
          paddingBottom: "0.75rem",
        }}
      >
        <span className="fs-16 contact_note_header ">Edit DOB</span>
      </ModalHeader>
      <ModalBody className="">
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            console.log("Form values:", values);
            close_editDob();
          }}
        >
          {(formik) => (
            <Form onSubmit={formik.handleSubmit}>
              <ModalBody className="p-0">
                <Row className="row m-0 p-0">
                  <Col xxl={12} className="ps-0">
                    <FormGroup>
                      <Label for="user_dob">Select DOB </Label>
                      <div className="position-relative">
                         {/* Icon inside input */}
                         <i
                          className="bx bx-calendar date-icon"
                          style={{
                            position: "absolute",
                            left: "15px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                            color: "#6c757d",
                            fontSize: "18px",
                          }}
                        />
                        <Flatpickr
                          id="user_dob"
                          name="user_dob"
                          className={`form-control ${
                            formik.touched.user_dob && formik.errors.user_dob
                              ? "is-invalid"
                              : ""
                          }`}
                          style={{ paddingLeft: "2.5rem" }}
                          placeholder="Select date"
                          value={formik.values.user_dob}
                          onChange={(date) => {
                            formik.setFieldValue("user_dob", date[0]);
                          }}
                          options={{
                            dateFormat: "d-m-Y",
                            maxDate: "today",
                          }}
                          onBlur={formik.handleBlur}
                        />
                       
                      </div>
                      <FormFeedback>{formik.errors.user_dob}</FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <div className="centerContent">
                <Button
                  className="fs-16"
                  color="primary"
                  type="submit"
                  style={{
                    minWidth: "120px",
                  }}
                >
                  Save
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default EditDobModal;
